import { render, staticRenderFns } from "./MarketingPoints.vue?vue&type=template&id=6a568af5&scoped=true"
import script from "./MarketingPoints.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarketingPoints.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MarketingPoints.vue?vue&type=style&index=0&id=6a568af5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a568af5",
  null
  
)

export default component.exports